import React from "react"

class SessionOverview extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      id,
      name,
      talent: { primaryPhoto },
      slug,
      showSessionInformation,
    } = this.props

    return (
      <div
        className="session-overview"
        onClick={() => {
          showSessionInformation(name)
        }}
      >
        <div className="session-overview__heading">
          <div className="session-overview_content">
            <h3 className="session-overview__name">{name}</h3>
            <div className="session-overview__arrow">
              <img src="/dropdown-right-arrow.svg" alt="" />
            </div>
          </div>
        </div>

        <div className="session-overview__image">
          <img src={`${slug}${primaryPhoto}`} alt="" />
        </div>
      </div>
    )
  }
}

export default SessionOverview
